module.exports = __webpack_public_path__ + "img/bgloginai.8e47cc7e.png";